// tslint:disable:max-classes-per-file

import { Action } from '@ngrx/store';

import { Shift } from '../../models/shift';

export const GET_SHIFT_SETTINGS = '[Shift] get shift settings';
export const GET_SHIFT_SETTINGS_SUCCESS = '[Shift] get shift settings success';
export const GET_SHIFT_SETTINGS_FAIL = '[Shift] get shift settings fail';

export class GetShiftSettings implements Action {
  public readonly type = GET_SHIFT_SETTINGS;

  constructor(public payload: any = null) {}
}

export class GetShiftSettingsSuccess implements Action {
  public readonly type = GET_SHIFT_SETTINGS_SUCCESS;

  constructor(public payload: Array<Shift>) {}
}

export class GetShiftSettingsFail implements Action {
  public readonly type = GET_SHIFT_SETTINGS_FAIL;

  constructor(public payload: any) {}
}

export type ShiftSettingsGetActions =
  | GetShiftSettings
  | GetShiftSettingsSuccess
  | GetShiftSettingsFail;
